import React, { Fragment, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { Redirect, withRouter } from 'react-router-dom'
import InternetIssue from '../../components/InternetIssue/InternetIssue'
import LoaderNew from '../../components/LoaderNew/LoaderNew'
import PwdValidateModal from '../../components/PwdValidateModal/PwdValidateModal'
import Spinner from '../../components/Spinner/Spinner'
import InstructionUI from './instructionsUI'
import {
    FETCH_QUESTION_SET,
    HIDE_TIMER,
    INSTRUCTION,
    IS_TEST_DATA_LOADED,
    SET_TEST_STATUS,
    UPDATE_ANTHE_DATA,
    UPDATE_BASE_URL,
    UPDATE_CALCULATED_TIME_LEFT,
    UPDATE_DEVICE_ID,
    UPDATE_EXISTING_TEST_STATUS,
    UPDATE_GLOBAL_QUERY_PARAMS,
    UPDATE_GLOBAL_TEST_STATUS,
    UPDATE_LOADING_PERCENT,
    UPDATE_PACKAGE_ID,
    UPDATE_RESUMED_DATA,
    UPDATE_TEST_DURATION,
    UPDATE_TIME,
    UPDATE_HEADER_VISIBLE,
    TEST_PREVIEW,
    UPDATE_CURRENT_LANGUAGE,
    UPDATE_MOCK_TEST_SUBMIT,
    UPDATE_IP_ADDRESS,
} from '../../constants/actionTypes'

import './InstructionsPage.css'

import useInstructionsData from './useInstructionsData'
import { ANTHE_TEST_TYPES } from 'constants/examTypeConstants'

const mapStateToProps = (state) => ({
    disconnect_timer: state.disconnect_timer,
    packageId: state.packageId,
    instructions: state.instructions,
    deviceId: state.deviceId,
    queryparam: state.queryparam,
    testStatus: state.testStatus,
    current_language: state.current_language,
    correct_otp: state.correct_otp,
})

const mapDispatchToProps = (dispatch) => ({
    onQuestionLoad: (payload) => {
        dispatch({ type: FETCH_QUESTION_SET, payload })
    },
    onLoad: (payload) => dispatch({ type: INSTRUCTION, payload }),
    setTestStatus: (payload) => {
        dispatch({ type: SET_TEST_STATUS, payload })
    },
    setIpAddress: (payload) => dispatch({ type: UPDATE_IP_ADDRESS, payload }),
    resetTimer: (payload) => dispatch({ type: UPDATE_TIME, payload }),
    setTestDataLoadedStatus: (payload) =>
        dispatch({ type: IS_TEST_DATA_LOADED, payload }),
    setGlobalTestStatus: (payload) =>
        dispatch({ type: UPDATE_GLOBAL_TEST_STATUS, payload }),
    setQueryParam: (payload) =>
        dispatch({ type: UPDATE_GLOBAL_QUERY_PARAMS, payload }),
    setIsExistingTestParam: (payload) =>
        dispatch({ type: UPDATE_EXISTING_TEST_STATUS, payload }),
    setDeviceId: (payload) => dispatch({ type: UPDATE_DEVICE_ID, payload }),
    setResumedData: (payload) => dispatch({ type: UPDATE_RESUMED_DATA, payload }),
    setPackageId: (payload) => dispatch({ type: UPDATE_PACKAGE_ID, payload }),
    setBaseUrl: (payload) => dispatch({ type: UPDATE_BASE_URL, payload }),
    hideTimer: (payload) => dispatch({ type: HIDE_TIMER, payload }),
    setTestDuration: (payload) => dispatch({ type: UPDATE_TEST_DURATION, payload }),
    updateCalculatedTimeLeft: (payload) =>
        dispatch({ type: UPDATE_CALCULATED_TIME_LEFT, payload }),
    setLoadingPercent: (payload) =>
        dispatch({ type: UPDATE_LOADING_PERCENT, payload }),
    setAntheData: (payload) => dispatch({ type: UPDATE_ANTHE_DATA, payload }),
    setHeaderVisibility: (payload) =>
        dispatch({ type: UPDATE_HEADER_VISIBLE, payload }),
    setTestPreviewData: (payload) => dispatch({ type: TEST_PREVIEW, payload }),
    updateCurrentLanguage: (payload) => {
        dispatch({ type: UPDATE_CURRENT_LANGUAGE, payload })
    },
    setMockTestSubmit: (payload) =>
        dispatch({ type: UPDATE_MOCK_TEST_SUBMIT, payload }),
})

const InstructionsPage = (props) => {
    const { t } = useTranslation()
    const {
        loading,
        isError,
        errorMsg,
        isSecure,
        redirectToTestPanel,
        redirectToResults,
        showStartPreviewBtn,
        showLoginButton,
        connection,
        buttonText,
        giveTest,
        fetchData,
        fetchPreviewData,
        setRedirectToTestPanel,
        getUrlParameter,
    } = useInstructionsData(props)
    const tp_preview_token = getUrlParameter('tp_preview_token')
    const test_id = getUrlParameter('test_id')

    const isPreview = tp_preview_token && test_id

    useEffect(() => {
        if (isPreview) {
            fetchPreviewData({ tp_preview_token, test_id })
        } else {
            fetchData()
        }
    }, [])

    if (isError) {
        return (
            <InternetIssue
                message={errorMsg !== '' ? t(errorMsg) : t('Something Went Wrong')}
                showLoginButton={showLoginButton}
            />
        )
    }

    if (loading) {
        return (
            <LoaderNew
                done={0}
                title1={props.instructions?.testData?.titleEn}
                title2={t('while we are loading your test')}
                title3={null}
                title4={t('PLEASE DO NOT CLOSE THE BROWSER')}
            />
        )
    }

    if (redirectToTestPanel) {
        return <Redirect to="/testpanel" />
    }

    if (redirectToResults) {
        return <Redirect to="/results" />
    }

    const showPwdValidateModal =
        !isPreview &&
        ANTHE_TEST_TYPES.includes(props?.queryparam?.exam_type?.toLowerCase()) &&
        !props.correct_otp

    if (props.instructions?.testData) {
        return (
            <Fragment>
                {showPwdValidateModal ? <PwdValidateModal /> : null}
                <InstructionUI
                    isSecure={isSecure}
                    showStartPreviewBtn={showStartPreviewBtn}
                    connection={connection}
                    buttonText={buttonText}
                    instructions={props.instructions}
                    setRedirectToTestPanel={setRedirectToTestPanel}
                    giveTest={giveTest}
                />
            </Fragment>
        )
    }

    return <Spinner message={'loading'} />
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(InstructionsPage),
)
